import * as React from 'react'

import {IconProps} from '.'

function Remove({color, size}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect x="7" y="11" width="10" height="2" fill={color} />
    </svg>
  )
}

export default Remove
